<template>
<div>
  <van-panel title="👑 等级说明" class="level-sheet">
    <div slot="footer">
      <van-notice-bar text="💡 所有等级畅享低至二折优惠券，自动匹配高返利通道（最高5+倍）。PS：百分比基数是返利金额而非商品单价。" />

      <van-row class="level-header">
        <van-col span="6" class="level-header-no">
          <van-icon name="point-gift" />
          等级
        </van-col>
        <van-col span="6" class="level-header-buy">
          <van-icon name="points" />
          自购加成
        </van-col>
        <van-col span="6" class="level-header-invite">
          <van-icon name="discount" />
          邀请补贴
        </van-col>
        <van-col span="6" class="level-header-friend">
          <van-icon name="contact" />
          好友数量
        </van-col>
      </van-row>

      <van-row>
        <van-col span="6">
          <van-tag size="large" color="#ffb100">LV1</van-tag>
        </van-col>
        <van-col span="6">
          -
        </van-col>
        <van-col span="6">
          10%
        </van-col>
        <van-col span="6">
          -
        </van-col>
      </van-row>

      <van-row>
        <van-col span="6">
          <van-tag size="large" color="#ffb100">LV2</van-tag>
        </van-col>
        <van-col span="6">
          +10%
        </van-col>
        <van-col span="6">
          15%
        </van-col>
        <van-col span="6">
          5
        </van-col>
      </van-row>

      <van-row>
        <van-col span="6">
          <van-tag size="large" color="#ffb100">LV3</van-tag>
        </van-col>
        <van-col span="6">
          +20%
        </van-col>
        <van-col span="6">
          20%
        </van-col>
        <van-col span="6">
          20
        </van-col>
      </van-row>

      <van-row>
        <van-col span="6">
          <van-tag size="large" color="#ffb100">LV8</van-tag>
        </van-col>
        <van-col span="12">
          官方引流/月度津贴/貔貅特权
        </van-col>
        <van-col span="6">
          50
        </van-col>
      </van-row>
    </div>
  </van-panel>
</div>
</template>

<script>
import { Row, Col, Tag, List, Icon, Panel, NoticeBar } from "vant";

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [List.name]: List,
    [Icon.name]: Icon,
    [Panel.name]: Panel,
    [NoticeBar.name]: NoticeBar
  },
  data() {
    return {};
  }
};
</script>

<style lang="less">
.level {
  &-header {
    .van-icon {
      display: block;
      font-size: 24px;
      padding: 5px;
    }
    &-no {
      color: rgb(255, 177, 0);
    }
    &-buy {
      color: rgb(255, 64, 129);
    }
    &-invite {
      color: rgb(37, 155, 36);
    }
    &-friend {
      color: rgb(0, 128, 255);
    }
  }
  &-sheet {
    margin-top: 2rem;
    .van-panel__header {
      font-size: 36px;
      padding: 2rem;
    }
    .van-row {
      margin: 2rem 0;
    }
  }
}
</style>
